export default {
  "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])}
}